/**
 * Shared active-state class for the date filter pills (WEB-348, supersedes
 * WEB-287's amber active fill).
 *
 * Single source of truth so the preset radios (`DiscoverDatePills`) and the
 * custom-range popover trigger (`CustomRangePopover`) can never drift apart.
 *
 * Active-fill decision (WEB-348, 2026-05-24):
 *   - The DS v1.1.0 template (`docs/design-system/1.1.0/templates/app/discover.html:202`)
 *     defines `.disc-date.is-active` as `background: var(--clt-skyline)` with
 *     `color: #FFF` and a matching border.
 *   - WEB-287 had previously chosen the amber accent (`bg-accent`) so the
 *     active pill would not "read as one shade of gray" (audit 2026-06-10 #8).
 *   - This punchlist wave (WEB-345..349) explicitly defers to the template
 *     where reasonable, so we move to the template's skyline fill. The
 *     skyline → white contrast satisfies the same legibility intent as the
 *     amber → black contrast did, and unifies the date rail with the rest of
 *     the DS v1.1.0 active surfaces (checkbox row, category chip, etc.).
 *   - If the operator wants to retain amber for any reason, flip this back to
 *     `bg-accent text-accent-foreground border-accent` and re-update the
 *     story snapshots + unit tests.
 *
 * Notes:
 *   - We deliberately do NOT include any `hover:` overrides here. The pill
 *     button no longer uses the shadcn `Button variant="outline"` wrapper
 *     (which shipped `hover:bg-accent`/`hover:text-accent-foreground` and
 *     fought the active fill on touch devices via stuck-:hover after tap;
 *     see WEB-348 audit). Hover state is owned by the button's own class
 *     list and only inverts the border, not the fill.
 *   - Skyline tokens are theme-aware via `--clt-skyline` (light=#0e7b7b,
 *     dark=#2fa3a3 per WEB-332) — the active pill stays legible in both.
 */
export const ACTIVE_PILL_CLASS = 'bg-clt-skyline text-white border-clt-skyline';
